import * as excel from "@script/excel";
import { useState } from "react";
import ExcelUploadTemplate from "./ExcelUploadTemplate";

export default function MgmtMworksTab_position() {
  const [excelFileName, setExcelFileName] = useState<string>();
  const [excelDataMworks, setExcelDataMworks] = useState<any | null>(null);

  const [isUpload, setIsUpload] = useState(false);

  async function handleFileUpload(file: File) {
    setExcelDataMworks(null);

    setIsUpload(true);
    // 파일 유효성 검사
    if (file.size > 10 * 1024 * 1024) {
      alert("❌ 파일 크기는 10MB를 초과할 수 없습니다.");
      setIsUpload(false);
      return;
    }

    if (
      !file.name.toLowerCase().endsWith(".xlsx") &&
      !file.name.toLowerCase().endsWith(".xls")
    ) {
      alert("❌ 지원되지 않는 파일 형식입니다. (.xlsx, .xls만 지원)");
      setIsUpload(false);
      return;
    }
    setExcelFileName(file.name);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const uploadResult = await excel.upload_mworks_position(formData);
      const pasingData = JSON.parse(uploadResult);
      setExcelDataMworks(pasingData);
    } catch (error) {
      setExcelDataMworks({ result: "serverError" });
    } finally {
      setIsUpload(false);
    }
  }

  return (
    <ExcelUploadTemplate
      title="직위 등록"
      templateUrl="/template/easysetting_position.xlsx"
      templateFileName="직위등록_템플릿.xlsx"
      onFileUpload={handleFileUpload}
      isUpload={isUpload}
      excelFileName={excelFileName}
    >
      {excelDataMworks && (
        <div className="mgmtMworks_uploadResult">
          {excelDataMworks.result === "succeed" ? (
            <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--ok">
              업로드가 완료되었습니다
            </div>
          ) : excelDataMworks?.result ? (
            <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--error">
              업로드에 실패하였습니다.1
            </div>
          ) : (
            <>
              <div className="mgmtMworks_uploadResult_message mgmtMworks_uploadResult_message--error">
                업로드에 실패하였습니다.2
              </div>
              <table className="mgmtMworks_uploadError_table">
                <tbody>
                  {excelDataMworks.map((item: any, idx: number) => (
                    <tr key={idx}>
                      <td className="mgmtMworks_uploadError_td">{item.num}</td>
                      <td className="mgmtMworks_uploadError_td">
                        {item.Title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      )}
    </ExcelUploadTemplate>
  );
}
